module.exports = __webpack_public_path__ + "static/media/about.e2ebd884.jpg";